import { render, staticRenderFns } from "./ChallengeHeader.vue?vue&type=template&id=8d1a4970"
import script from "./ChallengeHeader.vue?vue&type=script&lang=ts"
export * from "./ChallengeHeader.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeHeader.vue?vue&type=style&index=0&id=8d1a4970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports